import { createDraftApi as generatedCreateDraftApi } from '../generated/quickDraft/createDraft';

const createDraftApi = generatedCreateDraftApi.enhanceEndpoints({
  endpoints: {
    createDraft: {
      invalidatesTags: (result, _error, { date }) => [
        ...(result?.draft?._id ? [{ id: result.draft._id, type: 'Drafts' as const }] : []),
        { id: date, type: 'Drafts' as const },
        { id: date, type: 'Slots' as const },
      ],
    },
  },
});

export const { useCreateDraftMutation } = createDraftApi;
